export const CONTACT_DESCRIPTION_MAX_LENGTH = 40
export const CONTACT_DESCRIPTION_MAX_LENGTH_MESSAGE_FROM = 35

export const PERMISSIONS_EXPIRES_AT_MIN_MESSAGE =
  'Дата должна быть не раньше завтрашнего дня'
